// extracted by mini-css-extract-plugin
module.exports = {"swatchCanvas":"iconSwatchCanvas_swatchCanvas__2RHj1"};